/**
 * descargarArchivo -- traer un archivo remoto (una imagen generada) como blob para ofrecerlo como descarga.
 *
 * CONTRATO-VISTA-PANEL-T1 (familia fetch directo; regla de dos): PublicidadView y NegocioDetailView repetian
 * `const response = await fetch(src); const blob = response.ok ? await response.blob() : null;`. Es la misma
 * peticion, en un solo lugar. No es la API de Nexo: es la URL del archivo (p. ej. la imagen remota), sin sesion.
 *
 * @module infrastructure/descargarArchivo
 */

/** @returns {Promise<Blob|null>} el blob, o null si la respuesta no es ok; lanza si no hay red (como antes) */
export async function blobDeUrl(src) {
  const response = await fetch(src);
  return response.ok ? await response.blob() : null;
}
